// Banner de consentimento de cookies (LGPD)
// Exibido no primeiro acesso; a escolha é salva no localStorage.
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Banner,
    BannerInner,
    TextBlock,
    Actions,
    AcceptButton,
    RejectButton,
    PolicyLink
} from './styled';

const STORAGE_KEY = 'cookie_consent';

/**
 * Lê a decisão de cookies salva.
 * @returns {'accepted' | 'rejected' | null}
 */
export const getCookieConsent = () => {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
};

/**
 * Avisa os rastreadores (Google e Meta) sobre a decisao da pessoa.
 * Sem isso o banner seria so enfeite: os scripts ja estao na pagina.
 */
const aplicarConsentimento = (value) => {
    const liberado = value === 'accepted' ? 'granted' : 'denied';
    try {
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage: liberado,
                ad_user_data: liberado,
                ad_personalization: liberado,
                analytics_storage: liberado,
            });
        }
        if (typeof window.fbq === 'function') {
            if (value === 'accepted') {
                window.fbq('consent', 'grant');
                window.fbq('track', 'PageView');
            } else {
                window.fbq('consent', 'revoke');
            }
        }
        window.__consentimentoCookies = value;
    } catch {
        // se algum rastreador nao carregou, nao ha o que atualizar
    }
};

const CookieConsent = () => {
    const history = useHistory();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Mostra apenas se ainda não houve decisão
        const decision = getCookieConsent();
        if (!decision) {
            setVisible(true);
        }
    }, []);

    const decide = (value) => {
        try {
            localStorage.setItem(STORAGE_KEY, value);
        } catch {
            // ignora falha de storage
        }
        aplicarConsentimento(value);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <Banner role="dialog" aria-label="Aviso de cookies" aria-live="polite">
            <BannerInner>
                <TextBlock>
                    🍪 Usamos cookies para melhorar sua experiência, analisar o uso da plataforma e
                    personalizar conteúdo. Você pode aceitar todos ou recusar os cookies não essenciais.
                    Saiba mais na nossa{' '}
                    <PolicyLink onClick={() => history.push('/politica-de-privacidade')}>
                        Política de Privacidade
                    </PolicyLink>.
                </TextBlock>
                <Actions>
                    <RejectButton onClick={() => decide('rejected')}>
                        Recusar não essenciais
                    </RejectButton>
                    <AcceptButton onClick={() => decide('accepted')}>
                        Aceitar todos
                    </AcceptButton>
                </Actions>
            </BannerInner>
        </Banner>
    );
};

export default CookieConsent;
